import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

export const StyledIconButton = styled(IconButton)`
  color: #1c1b1f;
  padding: 0;
`;
